
<template>
    <div class="text-caption">
        <div separator>
           <!--  v-bind:key="invest.index" v-for="invest in StoreStateT.Transaction.Investment" -->
            
                <q-item-section>
                    <q-item-label>
                        <div class="row ">
                            <div class="col-xs-12 col-md-6 q-px-sm" style="font-size: 14px">
                                <!-- <q-badge class="text-subtitle1" >{{ invest.SchemeName }}</q-badge> -->
                                <!-- <div>{{$t("FundInfo.fund")}}</div> -->
                                <div class="text-bold q-mb-md">{{InvestmentObj.SchemeName}}</div>

                                <!-- <div class="q-mb-sm">Documents</div> -->
                                <div class="q-mb-md">
                                    <q-chip class="chipBtn" outline square clickable style="font-size: 12px; width: 160px; background-color: #eff1fa !important;"  color="primary" v-if="InvestmentObj.ProspectusLink !=''"  @click="openProspectus(InvestmentObj.ProspectusLink)">
                                        {{$t("Buy.Prospectus")}}
                                    </q-chip>
                                    <q-chip class="chipBtn" outline square clickable style="font-size: 12px; width: 160px; background-color: #eff1fa !important;" color="primary" v-if="InvestmentObj.BrochureLink !=''" @click="openProspectus(InvestmentObj.BrochureLink)">
                                        {{$t("Buy.Brochure")}}
                                    </q-chip>
                                    <q-chip class="chipBtn" outline square clickable style="font-size: 12px; width: 160px; background-color: #eff1fa !important;" color="primary" v-if="InvestmentObj.PrdtHighlightLink !=''" @click="openProspectus(InvestmentObj.PrdtHighlightLink)" >
                                        {{$t("Buy.ProductHighlight")}}
                                    </q-chip>
                                    <q-chip class="chipBtn" outline square clickable style="font-size: 12px; width: 160px; background-color: #eff1fa !important;" color="primary" v-if="InvestmentObj.FundFactLink !=''" @click="openProspectus(InvestmentObj.FundFactLink)" >
                                        {{$t("Buy.FundFact")}}
                                    </q-chip>

                                </div>
                                <!-- <q-input :label='$t("FundInfo.fund")'  :value="InvestmentObj.SchemeName" readonly borderless /> -->
                            </div>

                            <div class="col-xs-12 col-md-3 q-px-sm">
                                <!-- <q-item-label  caption lines="2">Sales Charge : {{ invest.SalesCharge }}%</q-item-label> -->
                                <b>{{$t("FundInfo.salescharge")}}</b>
                                <!-- {{InvestmentObj.SalesCharge}} -->
                                <q-input outlined  :value="InvestmentObj.SalesCharge" readonly style="margin-bottom: 20px;"/>
                            </div>

                            <div class="col-xs-12 col-md-3 q-px-sm">
                                <b>{{$t("FundInfo.amount")}}</b>
                              <q-input
                                outlined
                                
                                input-class="text-right"
                                class="text-right" 
                                v-model="fValue"
                                :rules="[ val => RemoveFormat(val) >= InvestmentObj.MinimumInitialInvestment  || '' + $t('Buy.minimumInvestment') +' ' + + parseFloat(InvestmentObj.MinimumInitialInvestment).toFixed(2)  ]" 
                                />
                              
                             </div>
                            
                        </div> 
                        <div class="row">
                            
                         <div class="col-12" style="float:right; padding-bottom: 20px">
                             
                                <CB style="" class="q-px-sm" @RemoveButton="RemoveFund(InvestmentObj.SchemeName, InvestmentObj.count)" :ShowRemoveButton=true />
                            </div>
                        </div>
                       <!-- <div class="row">
                            <div class="col-1">
                                <CB class="q-px-md q-pb-md" @RemoveButton="RemoveFund(invest.SchemeName)" :ShowRemoveButton=true />
                            </div>
                        </div>-->
                    </q-item-label>
                </q-item-section>
            
            <q-separator class="q-mb-md" />
        <!--     <q-item v-if="StoreStateT.Transaction.Investment.length < 1">
                <q-item-section>
                    No Content
                </q-item-section>
            </q-item> -->
        </div>
    </div>
</template>

<style>
.q-chip__content.col.row.no-wrap.items-center.q-anchor--skip {
    text-align: center;
    display: block;
}

@media screen and (max-width: 768px) {
    .q-chip.row.inline.no-wrap.items-center.text-primary.q-chip--colored.q-chip--outline.q-chip--clickable.cursor-pointer.non-selectable.q-hoverable.q-chip--square{
        width: 100% !important;
        margin: 4px 0px !important;
    }
}
</style>

<script>
import { mapActions } from 'vuex';

import CB from "@/components/CartButtons";
import store from '../store'
export default {
    name : 'ListOfTransaction',
    components : {
        CB
    },
    data() {
        return {
            StoreStateT : store.state.Transactions,
    
            Form : {
                Amount : 0
            }
        }
    },  
    props: {
        InvestmentObj:Object,
    },
    mounted() {
        this.fValue = this.InvestmentObj.Amount
    },
   
    methods: {
        RemoveFund:function(obj,count){
            var vm = this;
              this.$q.dialog({
                    title : 'Notice',
                    message : 'Are you sure to continue with fund removal',
                    persistent : true,
                       ok: {
                            color: 'red-5',
                            push: false,
                            label: 'Proceed',
                        },
                    cancel: {
                            flat: true,
                            push: false,
                            color: 'grey'
                            
                        },
                }).onOk(() => {
                    for(var i = 0; i< this.StoreStateT.Transaction.Investment.length; i++){
                        if((this.StoreStateT.Transaction.Investment[i].SchemeName === obj)&&(this.StoreStateT.Transaction.Investment[i].count === count)){
                            this.StoreStateT.Transaction.Investment.splice(i,1)
                        }
                    }
                }).onCancel(() => {
                   // console.log('Cancel')
                })
          
        },
        RemoveFormat (obj){
             var vall= obj;
            vall = vall.replace(",","").replace(",","");
            vall = vall.replace(",","").replace(",","");
            return vall.trim()
        },
        openProspectus:function(obj){
            window.open(obj);
        },
    },
    filters: {
        thousandSeparator: function(value) {
            if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return value;
            }
        }
    },
     computed: {
        fValue: {
            get: function () {
                return this.InvestmentObj.Amount;
            },

            set: function (newValue) {

                if(/[a-zA-Z]/g.test(newValue)){
                    return
                }

                if (newValue.length <= 2) {
                    return this.InvestmentObj.Amount = newValue
                }

                var valToFind = '.'
                if(newValue.indexOf(valToFind) > -1){
                    newValue = newValue.replace(".","").replace(".","");
                }else{
                    newValue = newValue
                }

                this.InvestmentObj.Amount = newValue.substr(0, newValue.length - 2) + "." + newValue.substr(newValue.length - 2);
                let num_parts = this.InvestmentObj.Amount.toString().split(".");
                const result = num_parts[0].replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.InvestmentObj.Amount = result + '.' + num_parts[1]
            }
        }
        }
    
}
</script>
<style>
.titleHeader{
    
    font-size: 18px;
}
.secondaryHeader{
    font-size: 16px;
}

.amountInput>.q-field>.q-field__inner>.q-field__control>
.q-field__control-container>.q-field__label{
    text-align: right;
}

.amountInput>.q-field>.q-field__inner>.q-field__control>
.q-field__control-container>.q-field__native{
    text-align: right;
    color: #2f56e2;
    font-weight: 400;
}

.salesCharge>.q-input>.q-field__inner>.q-field__control>.q-field__control-container>
.q-field__native {
    color: #2f56e2;
    font-weight: 400;
}


.schemeName>.q-field>.q-field__inner>.q-field__control>.q-field__control-container>.q-field__native{
    
    color: #2f56e2;
    font-weight: 400;
}
</style>